import React from "react";
import { StaticImage } from "gatsby-plugin-image";

const navLinks = [
  {
    slug: "",
    label: "India Shrimp: A Growing Goliath",
    is_landing: true,
  },
  {
    label: "Investigation",
    slug: "investigation",
    in_nav_desktop: false,
    in_nav_mobile: false,
    in_footer: true,
    links: [
      {
        label: "The Whistleblower",
        slug: "the-whistleblower",
      },
      {
        label: "Videos",
        slug: "videos",
      }
    ]
  },
  {
    label: "Reporting",
    slug: "reporting",
    feature: true,
    in_nav_desktop: false,
    in_nav_mobile: true,
    in_footer: false,
    links: [
      {
        label: "The Whistleblower",
        slug: "the-whistleblower",
        image: <StaticImage src="../../images/main.jpg" alt="" />,
        postlabel: "Read the Investigation",
        feature: true
      },
      {
        label: "Indian Shrimp Rife with Bondage, Hazards, and Stolen Wages",
        slug: "indian-shrimp-rife-with-bondage-hazards-and-stolen-wages",
        image: <StaticImage src="../../images/sidebar_e.jpg" alt="" />
      },
      {
        label: "Researchers Point to Flaws in Audit Industry",
        slug: "researchers-point-to-flaws-in-audit-industry",
        image: <StaticImage src="../../images/sidebar_c.jpg" alt="" />
      },
      {
        label: "The Rise of All-You-Can-Eat Shrimp",
        slug: "the-rise-of-all-you-can-eat-shrimp",
        image: <StaticImage src="../../images/sidebar_d.jpg" alt="" />
      },
      {
        label: "Lax FDA Enforcement Lets Unsafe Shrimp Reach Shelves",
        slug: "lax-fda-enforcement-lets-unsafe-shrimp-reach-shelves",
        image: <StaticImage src="../../images/sidebar_b.png" alt="" />
      }
    ]
  },
  {
    label: "The Whistleblower",
    slug: "the-whistleblower",
    in_nav_desktop: true,
    in_nav_mobile: false,
    in_footer: false,
  },
  {
    slug: "more-reporting",
    label: "More Reporting",
    in_nav_desktop: true,
    in_nav_mobile: false,
    in_footer: true,
    links: [
      {
        label: "Indian Shrimp Rife with Bondage, Hazards, and Stolen Wages",
        slug: "indian-shrimp-rife-with-bondage-hazards-and-stolen-wages",
        image: ""
      },
      {
        label: "Researchers Point to Flaws in Audit Industry",
        slug: "researchers-point-to-flaws-in-audit-industry",
        image: ""
      },
      {
        label: "The Rise of All-You-Can-Eat Shrimp",
        slug: "the-rise-of-all-you-can-eat-shrimp",
        image: ""
      },
      {
        label: "Lax FDA Enforcement Lets Unsafe Shrimp Reach Shelves",
        slug: "lax-fda-enforcement-lets-unsafe-shrimp-reach-shelves",
        image: ""
      }
    ]
  },
  {
    label: "Videos",
    slug: "videos",
    in_nav_desktop: true,
    in_nav_mobile: true,
    in_footer: false
  },
  {
    label: "Discussion",
    slug: "discussion",
    in_nav_desktop: true,
    in_nav_mobile: true,
    in_footer: false,
    visible_min: "80em",
    visible_min_landing: "64em",
  },
  {
    label: "Documents",
    slug: "documents",
    is_link: true,
    in_nav_desktop: true,
    in_nav_mobile: false,
    in_footer: true,
    visible_min: "80em",
    visible_min_landing: "64em",
    links: [
      {
        label: "Audio Files",
        slug: "documents/audio",
      },
      {
        label: "Miscellaneous",
        slug: "documents/miscellaneous",
      },
      {
        label: "Customers",
        slug: "documents/customers",
      },
      {
        label: "Antibiotics & Shrimp",
        slug: "documents/antibiotics-and-shrimp",
      },
      {
        label: "Company Discussions",
        slug: "documents/company-discussions",
      },
    ]
  },
  {
    label: "Documents",
    slug: "documents",
    in_nav_desktop: false,
    in_nav_mobile: true,
    in_footer: false,
  },
  {
    label: "Methodology",
    slug: "methodology",
    in_nav_desktop: true,
    in_nav_mobile: true,
    in_footer: false,
    visible_min: "80em",
    visible_min_landing: "64em",
  },
  {
    label: "Context",
    slug: "context",
    in_nav_desktop: true,
    in_nav_mobile: false,
    in_footer: false,
    visible_min: "80em",
    visible_min_landing: "64em",
    links: [
      {
        label: "Discussion",
        slug: "discussion",
      },
      {
        label: "Documents",
        slug: "documents",
      },
      {
        label: "Methodology",
        slug: "methodology",
      }
    ]
  },
  {
    label: "Context",
    slug: "context",
    in_nav_desktop: false,
    in_nav_mobile: false,
    in_footer: true,
    links: [
      {
        label: "Documents",
        slug: "documents",
      },
      {
        label: "Methodology",
        slug: "methodology",
      }
    ]
  },
  {
    label: "Impact",
    slug: "impact",
    in_nav_desktop: true,
    in_nav_mobile: true,
    in_footer: false,
  },
  {
    label: "Reach",
    slug: "reach",
    in_nav_desktop: true,
    in_nav_mobile: true,
    in_footer: false,
  },
  {
    label: "Subscribe",
    slug: "subscribe",
    in_nav_desktop: false,
    in_nav_mobile: true,
    in_footer: false,
    href: "https://theoutlawocean.substack.com/"
  }
];

export default navLinks;